var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-planet__3d"})
}
var staticRenderFns = []

export { render, staticRenderFns }